module.exports = __webpack_public_path__ + "static/media/paper6.bd6f770f.png";